import { useRef } from "react";
import { useInView } from "react-intersection-observer";
import exportToPdf from "../../utils/exportToPdf";

export const EventsList = ({ heading, eventsFields, className }) => {
  const [slideUpRef, isInView] = useInView({ triggerOnce: true });
  const targetRef = useRef(null);
  const handleExport = () =>
    exportToPdf(targetRef, {
      filename: "ScreeningEvents.pdf",
      margin: { top: 16, bottom: 16, left: 32, right: 32 },
    });
  return (
    <div
      ref={slideUpRef}
      className={`tw-flex tw-flex-col tw-gap-8 tw-items-center tw-w-full md:tw-w-max tw-max-w-2/3 ${
        isInView ? "slide-up" : ""
      } ${className}`}
    >
      <button
        className="link tw-bg-transparent tw-w-max tw-px-20 md:-tw-mt-24 tw-translate-y-28 md:tw-translate-y-72 tw-self-end"
        onClick={handleExport}
      >
        Download PDF
      </button>
      <div
        className="tw-flex tw-flex-col tw-gap-8 tw-items-center"
        ref={targetRef}
      >
        {heading && (
          <h2 className="tw-self-start md:tw-self-auto tw-pl-10 md:pl-0 heading2">
            {heading}
          </h2>
        )}
        <div className="tw-bg-[#f2f5fa] tw-w-full tw-p-16">
          {eventsFields.map((event, index) => {
            const isLastItem = index + 1 === eventsFields.length;
            return (
              <div
                className={`tw-flex tw-flex-col tw-gap-1 tw-items-start tw-w-full pb-5`}
                style={{
                  borderBottom: "1px solid #4e87a0",
                }}
              >
                <h3 className={`heading3 ${index != 0 ? "tw-pt-6" : ""}`}>
                  {event.event_name}
                </h3>
                <p className="tw-font-bold text-[#3a434f]">
                  {event.event_date}{" "}
                  {event.location ? `• ${event.event_location}` : ""}
                </p>
                {event.event_details && (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: event.event_details,
                    }}
                  />
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
